const routes = [{
  path: '/pagenotfound',
  name: 'PageNotFound',
  component: () => import('@src/common/view/common/PageNotFound'),
  meta: {
    requireAuth: true
  }
}, {
  path: '/unauthorized',
  name: 'Unauthorized',
  component: () => import('@src/common/view/common/Unauthorized'),
  meta: {
    requireAuth: true
  }
}, {
  path: '/licence',
  name: 'licence',
  component: () => import('@src/common/view/common/licence'),
  meta: {
    requireAuth: true
  }
}];
export default routes
